import { EventEmitter, OnInit, TemplateRef } from '@angular/core';
var CsDropDownItemTemplatesComponent = /** @class */ (function () {
    function CsDropDownItemTemplatesComponent() {
        this.onItemClick = new EventEmitter();
        this.onItemElementClick = new EventEmitter();
    }
    CsDropDownItemTemplatesComponent.prototype.ngOnInit = function () {
    };
    CsDropDownItemTemplatesComponent.prototype.itemClick = function (item) {
        this.onItemClick.emit(item);
    };
    CsDropDownItemTemplatesComponent.prototype.itemElementClick = function (data) {
        // data.item.indicatorIcon = data.item.templateData.iconsList.find(icon => icon.isItemIndicator) || null;
        this.onItemElementClick.emit(data);
    };
    return CsDropDownItemTemplatesComponent;
}());
export { CsDropDownItemTemplatesComponent };
